export default class NotFoundError extends Error {
  static CODE = 'not-found'

  constructor(resource, id, message) {
    super(message)
    this.code = NotFoundError.CODE
    this.resource = resource
    this.id = id
  }
}
